/**
 * 组件使用场景：流拍提醒
 * 组件使用 -> API:dispatch.abortiveAuction.show({
 *  id:'',
 *  stateTip: '',
 *  callBack: ()=>{}
 * }) 展开model => id为逻辑必需值
 *
 * API使用 ->
 * API:import { showAbortiveAuction } from '@/shared/utils';
 * showAbortiveAuction({
 *  id:'',
 *  stateTip: '',
 *  callBack: ()=>{}
 * }) 展开model => id为逻辑必需值
 *
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Icon } from 'antd';
import { Provider, connect } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    abortiveAuction: rootState.abortiveAuction,
});
class AbortiveAuctionComponent extends Component {
    constructor(props) {
        super(props);
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
    }
    cancel() {
        dispatch.abortiveAuction.hide();
    }
    afterClose() {
        this.props.form.resetFields();
    }
    ok() {
        const props = this.props;
        dispatch.abortiveAuction.confirm(props.form);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { visible, stateTip } = this.props.abortiveAuction;
        return (<Modal centered closable={false} okText="继续" onOk={this.ok} cancelText="取消" onCancel={this.cancel} visible={visible} afterClose={this.afterClose}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
        }}>
          <Icon type="exclamation-circle" theme="filled" style={{
            color: '#F9BF32',
            fontSize: 30,
            marginRight: 10,
        }}/>
          流拍提醒
        </div>
        <div style={{
            marginLeft: 40,
        }}>
          <div style={{
            margin: '10px 0',
        }}>
            <span style={{
            color: '#ED4633',
        }}>
              {`正在${stateTip}中的车辆流拍`}
            </span>
            ，你确定继续吗？
          </div>
          <Form.Item colon={false}>
            {getFieldDecorator('failureReason', {
            rules: [
                {
                    required: true,
                    message: '请输入流拍原因',
                },
                {
                    max: 20,
                    message: '限20字',
                },
            ],
        })(<Input.TextArea placeholder="请输入流拍原因（必填）" autoSize={{
            minRows: 4,
            maxRows: 4,
        }}/>)}
          </Form.Item>
        </div>
      </Modal>);
    }
}
AbortiveAuctionComponent.defaultProps = {};
const AbortiveAuctionFrom = Form.create()(AbortiveAuctionComponent);
const Index = connect(mapStateToProps, null, null, { forwardRef: true })(AbortiveAuctionFrom);
export default Index;
/**
 * API
 * */
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    div.className = 'souche-abortive-auction';
    document.body.appendChild(div);
    const refFn = (ref) => {
        componentRef = ref;
    };
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(Index, {
        ref: refFn,
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showAbortiveAuction({ data, stateTip, callback }) {
    if (!componentRef) {
        createAbortiveAuction();
    }
    dispatch.abortiveAuction.show({ data, stateTip, callback });
}
